import i18n from "i18next";
import {
  _LSPublishToLMS,
  fetchSubtitleLanguages,
  fetchAllSubtitlesForLanguage,
} from "../../common/server_utils.es6";

async function loadSubtitleBundleForLmsExport() {
  if (!window.idealStudioTrainingId || !window.ideaLibraryRootUrl) {
    return null;
  }

  const languagesResponse = await fetchSubtitleLanguages();
  let languages = [];
  if (Array.isArray(languagesResponse)) {
    languages = languagesResponse;
  } else if (languagesResponse && Array.isArray(languagesResponse.availableLanguages)) {
    languages = languagesResponse.availableLanguages;
  } else if (languagesResponse && Array.isArray(languagesResponse.data)) {
    languages = languagesResponse.data;
  }

  const languageCodes = Array.from(
    new Set(
      (languages || [])
        .map((langObj) => {
          if (!langObj) return null;
          if (typeof langObj === "string") return langObj;
          return langObj.languageCode || langObj.langCode || langObj.code || null;
        })
        .filter(Boolean)
    )
  );

  const subtitlesByLanguage = {};

  for (const langCode of languageCodes) {
    try {
      const data = await fetchAllSubtitlesForLanguage(langCode);

      let scenesArray = [];
      if (Array.isArray(data)) scenesArray = data;
      else if (data && Array.isArray(data.scenes)) scenesArray = data.scenes;
      else if (data && Array.isArray(data.data)) scenesArray = data.data;

      const transcriptsByScene = {};
      if (scenesArray && scenesArray.length > 0) {
        scenesArray.forEach((scene) => {
          let transcript = null;
          if (scene && scene.subtitle && scene.subtitle.transcript)
            transcript = scene.subtitle.transcript;
          else if (scene && scene.transcript) transcript = scene.transcript;

          if (transcript) {
            const sceneId = (scene && (scene.navId || scene.id || scene.sceneId)) || null;
            if (sceneId) transcriptsByScene[sceneId] = transcript;
          }
        });
      }

      subtitlesByLanguage[langCode] = transcriptsByScene;
    } catch (err) {
      console.error(`Subtitle fetch failed for ${langCode}:`, err);
      subtitlesByLanguage[langCode] = {};
    }
  }

  return { languages: languages || [], subtitlesByLanguage };
}

export const createLmsExporter = ({ getStoreState, setState, getTrainingId }) => {
  const doExport = async (overWrite) => {
    setState({ lmsExporting: true, lmsOverwriteDialog: true, lmsExportResult: null });

    const storeState = getStoreState();
    const present = storeState.undoGroup.present;

    const payload = {
      ...present,
      filesUploaded: storeState.filesUploaded,
      status: storeState.status,
    };

    const title = present.globalConfig?.title;

    let subtitleBundle = null;
    try {
      subtitleBundle = await loadSubtitleBundleForLmsExport();
    } catch (err) {
      console.error("Failed to load subtitle bundle for LMS export:", err);
      subtitleBundle = null;
    }

    payload.subtitleBundle = subtitleBundle || null;

    // eslint-disable-next-line no-undef
    IdealStudio.Visor.exportToLMS(
      payload,
      (error, blob, exportTitle) => {
        if (error) {
          let errorMessage = i18n.t("messages.error");
          if (error === "downloadFailed" || (error && error.message === "downloadFailed")) {
            errorMessage = i18n.t("export.download_failed", "İndirme tamamlanamadı");
          } else if (typeof error === "string") {
            errorMessage = error;
          }

          setState({
            lmsExporting: false,
            lmsExportResult: {
              success: false,
              message: errorMessage,
            },
          });
          return;
        }

        _LSPublishToLMS({
          idealStudioTrainingId: getTrainingId(),
          title: title || exportTitle,
          overWrite: overWrite,
          zipBlob: blob,
        })
          .then((result) => {
            setState({
              lmsExporting: false,
              lmsExportResult: {
                success: true,
                message: i18n.t("messages.LmsExportSuccess"),
              },
              lmsLogCreatedAt: new Date().toISOString(),
            });
          })
          .catch((err) => {
            setState({
              lmsExporting: false,
              lmsExportResult: {
                success: false,
                message: typeof err === "string" ? err : i18n.t("messages.error"),
              },
            });
          });
      },
      true
    );
  };

  return { doExport };
};
